/**
 * Hand-coded shopping situational phrases (ESL → Japanese L1 kana).
 * License: CC BY-SA 4.0.
 */

import type { SituationCard } from '../../situations/types.js';

const shopping: SituationCard[] = [
  {
    id: 'shopping.just-looking',
    situationId: 'shopping.just-looking',
    front: 'Thanks, I\'m just looking for now.',
    back: 'ありがとうございます。今はちょっと見ているだけです。',
    category: 'shopping',
    cefr: 'A1',
    translations: { ja: 'ありがとうございます。いまはちょっとみているだけです。' },
    speechAct: 'refusal',
    formality: 'polite',
    channel: 'in-person',
    pragmaticNote: {
      en: '"Just looking" is the standard polite refusal of help in retail. Add "thanks" so it doesn\'t come across as cold.',
      ja: '"Just looking"はお店で店員さんを丁寧に断る定型句。"thanks"を添えると印象がよくなります。'
    }
  },
  {
    id: 'shopping.how-much',
    situationId: 'shopping.how-much',
    front: 'How much is this?',
    back: 'これはいくらですか？',
    category: 'shopping',
    cefr: 'A1',
    translations: { ja: 'これはいくらですか？' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'shopping.try-on',
    situationId: 'shopping.try-on',
    front: 'Could I try this on, please?',
    back: 'これを試着してもいいですか？',
    category: 'shopping',
    cefr: 'A2',
    translations: { ja: 'これをしちゃくしてもいいですか？' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'shopping.different-size',
    situationId: 'shopping.different-size',
    front: 'Do you have this in a smaller size?',
    back: 'これの小さいサイズはありますか？',
    category: 'shopping',
    cefr: 'A2',
    translations: { ja: 'これのちいさいサイズはありますか？' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'shopping.return-item',
    situationId: 'shopping.return-item',
    front: "I'd like to return this — I have the receipt.",
    back: 'これを返品したいのですが。レシートはあります。',
    category: 'shopping',
    cefr: 'B1',
    translations: { ja: 'これをへんぴんしたいのですが。レシートはあります。' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'shopping.card-or-cash',
    situationId: 'shopping.card-or-cash',
    front: "I'll pay by card, thanks.",
    back: 'カードで支払います。',
    category: 'shopping',
    cefr: 'A2',
    translations: { ja: 'カードでしはらいます。' },
    speechAct: 'opinion',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'shopping.gift-wrap',
    situationId: 'shopping.gift-wrap',
    front: 'Could you gift-wrap this for me, please?',
    back: 'プレゼント用に包んでいただけますか？',
    category: 'shopping',
    cefr: 'B1',
    translations: { ja: 'プレゼントようにつつんでいただけますか？' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'shopping.complain-quality',
    situationId: 'shopping.complain-quality',
    front: 'I bought this last week, but there\'s a defect — could you exchange it?',
    back: '先週買ったのですが、不良品で……交換していただけますか？',
    category: 'shopping',
    cefr: 'B2',
    translations: { ja: 'せんしゅうかったのですが、ふりょうひんで……こうかんしていただけますか？' },
    speechAct: 'complaint',
    formality: 'polite',
    channel: 'in-person',
    pragmaticNote: {
      en: 'English complaint pattern: factual statement + softener ("—") + request. Avoid starting with "I am angry" — escalates the interaction unnecessarily.',
      ja: '英語のクレームは「事実→クッション→依頼」の流れ。最初に怒りを表現すると逆効果になりがち。'
    }
  },
  {
    id: 'shopping.bag-please',
    situationId: 'shopping.bag-please',
    front: "Could I get a bag, please?",
    back: '袋をいただけますか？',
    category: 'shopping',
    cefr: 'A1',
    translations: { ja: 'ふくろをいただけますか？' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  }
];

export default shopping;
